var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.7C14.5,63.7,0.3,49.5,0.3,32S14.5,0.3,32,0.3S63.7,14.5,63.7,32S49.5,63.7,32,63.7z M32,5.1 C17.1,5.1,5.1,17.1,5.1,32S17.1,58.9,32,58.9S58.9,46.9,58.9,32S46.9,5.1,32,5.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.7,37.9 31.1,37.9 31.1,26.5 41.1,26.5 41.1,22.2 26.9,22.2 26.9,42.1 37.8,42.1 45.6,50.2  48.7,47.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.6,21c3.1,0,5.8-2.7,5.8-5.8c0-3.2-2.6-5.8-5.8-5.8s-5.8,2.6-5.8,5.8S28.4,21,31.6,21z M31.6,16.7 c-0.8,0-1.6-0.8-1.6-1.6s0.8-1.6,1.6-1.6c0.8,0,1.6,0.8,1.6,1.6S32.3,16.7,31.6,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.6,47.2c-0.5,0.5-1,0.9-1.5,1.3c-2.2,1.5-4.9,2.1-7.5,1.6c-2.7-0.5-4.9-2-6.4-4.3 c-1.5-2.2-2.1-4.9-1.6-7.5c0.5-2.7,2-4.9,4.3-6.4l1.1-0.7l-2.5-3.5l-1,0.7c-4,2.6-6.3,7.1-6.3,11.9c0,7.9,6.4,14.3,14.3,14.3 c3.8,0,7.4-1.5,10.2-4.3l0.9-0.9l-3-3L36.6,47.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType23);
export default __webpack_public_path__ + "static/media/aioa-icon-type-23.abbd9c866c3de23f042d90459f5d2277.svg";
export { ForwardRef as ReactComponent };